import SectionHeading from '@/components/base/SectionHeading';
import { benefits, whyImage } from '@/mocks/home';

export default function WhyUs() {
  return (
    <section id="why-us" className="py-16 md:py-20 lg:py-[112px] px-4 md:px-6 lg:px-20 bg-background-100">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-center">
        <div className="lg:col-span-5">
          <div data-reveal="image" className="w-full h-[420px] md:h-[560px] lg:h-[640px] rounded-[20px] overflow-hidden">
            <img loading="lazy" decoding="async" src={whyImage} alt="CLEARY cleaner wiping a bathroom mirror" title="Detailed home cleaning — CLEARY" className="w-full h-full object-cover object-top" />
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <SectionHeading eyebrow="THE CLEARY DIFFERENCE" title="Good Cleaning Is in the Details." sub="Small things make a home feel truly cared for. We focus on them, visit after visit." />
          <div data-reveal-group className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-8">
            {benefits.map((b) => (
              <div key={b.title} className="border-t border-background-300 pt-6">
                <span className="w-11 h-11 rounded-full bg-background-200 text-secondary-500 flex items-center justify-center mb-5"><i className={`${b.icon} text-xl`} /></span>
                <h3 className="text-lg font-medium leading-[1.3]">{b.title}</h3>
                <p className="mt-2 text-[15px] leading-[1.6] text-foreground-600">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}